import {
    GET_EXPORT_STATUS_DONE,
    INITIATE_EXPORT_DONE
} from '../actions'
import pick from 'lodash/pick';
const initState = {
    in_progress: 0,
    exporter: '',
    exported_at: '',
    fetched: false
}
export default (state = initState, action) => {
    switch(action.type) {
        case INITIATE_EXPORT_DONE: 
        case GET_EXPORT_STATUS_DONE:
            return { ...state, ...pick(action.payload, Object.keys(initState)), fetched: true };
        default:
            return state;
    }
}